<template>
    <div class="pages noScroll">
        <div class="page noScroll">

            <div class="banner-title">
                <div class="title-isletCountryCity">
                    <span class="title-islet">{{countryModel.continent}}</span> &gt;
                    <span class="title-country">{{countryModel.countryCNName}}</span> &gt;
                    <span class="title-city">{{cityPartRecordViewModel.cityCNName}}</span>
                </div>
                <div class="replace-desination" @click="showDestinationOption">更换目的地</div>
            </div>

            <DestinationOption
                    :isShow="isShow"
                    :continent="countryModel.continent"
                    :country="countryModel.countryCNName"
                    :city="cityPartRecordViewModel.cityCNName"
                    :options="continentOptions"
                    @on-close="closeOption"></DestinationOption>

            <div class="page-content  infinite-scroll noScroll">
                <div class="shore-sightseeing-content">
                    <div class="shore-sightseeing">
                        <div class="shore-sightseeing-contentBg">
                            <div class="shorex-banner-content">

                                <div class="banner-titleImg">
                                    <img :src="cityPartRecordViewModel.mobileCityBannerUrl" :alt="cityPartRecordViewModel.cityCNName">
                                </div>
                                <div class="banner-desinaRoute">
                                    <div class="desinationRoute-txt"><router-link :to="`/Rccl.Cruise/CruiseSearch/Search?offset=0&destinationCodes=${cityPartRecordViewModel.code}`" class="external" href="">查找该目的地航线</router-link></div>
                                </div>
                            </div>
                            <div class="sightseeing-content">
                                <div class="threeReasons">
                                    <img style="width: 100%" src="../../assets/threeReasons.png" alt="三大理由">
                                </div>
                            </div>

                            <div class="shightseeing-reason-content">
                                <div class="title-reason"></div>
                                <div v-if="shorexIntroPartRecordViewModels.length > 0">
                                    <div class="tourMode-content boutiqueTour">
                                        <div class="tourMode-title">精品游</div>
                                        <div class="boutiqueTour-content">
                                            <div class="tourMode-imgIntro" v-for="(item, index) in shorexIntroPartRecordViewModels" :key="item.id">
                                                <div class="tourMode-title-img">
                                                    <img :src="item.bannerImage" :alt="item.shorexName">
                                                </div>
                                                <div class="imgIntro-content">
                                                    <div class="imgIntro-title"> {{index + 1}}】{{item.shorexName}}</div>
                                                    <div class="imgIntro-title-txt">{{item.shorexBrief}}</div>
                                                </div>
                                                <div class="tour-describe-content">
                                                    <div class="tour-time-price">
                                                        <div class="tour-time">
                                                            <img src="../../assets/timeImg.png">
                                                            <div class="time_txt">时长:<span>{{item.duration}}</span></div>
                                                            <div class="boutique--foodSign" v-if="item.shorexTagShow">
                                                                <img v-if="item.shorexTagShow.image" :src="item.shorexTagShow.image" alt="" />
                                                                <span v-if="item.shorexTagShow.tagName">{{item.shorexTagShow.tagName}}</span>
                                                            </div>
                                                        </div>
                                                        <div class="tour-price">
                                                            <img src="../../assets/priceImg.png">
                                                            <div class="price_txt">
                                                                <span>{{item.shorexPrice}}</span>美金/人
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="tour-describe">
                                                        <div class="describe-txt">{{item.shorexDescription}}</div>
                                                        <div class="boutique--tour-recentSail" v-if="item.cruisePartAndIntroPardApis&&item.cruisePartAndIntroPardApis.length>0">
                                                            <img src="https://resource.rcclchina.com.cn/shorex/shipIcon.png" alt="">
                                                            <span>
                                                                近期航次推荐：{{getCruiseTitle(item.cruisePartAndIntroPardApis)}}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- <div class="tourMode-content routineTour dn">
                                        <div class="routine-tour-title">常规游</div>
                                        <div class="routeTour-content">
                                            <div class="routine-place-content">
                                                <div class="routine-place-desc">
                                                    <div class="place-title-time">
                                                        <div class="place-time">长崎风情游 -约4.5小时</div>
                                                        <div class="place-title">和平公园-山田综合电器店</div>
                                                    </div>
                                                    <div class="royal-gift">皇家赠送</div>
                                                </div>
                                                <div class="routine-place-desc">
                                                    <div class="place-title-time">
                                                        <div class="place-time">冲绳常规游(冲绳第一日) -约5.5小时</div>
                                                        <div class="place-title">第一日:首里城(不等城)-Outlet Mall-综合免税店</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div> -->

                                    <div class="route-destination">
                                        <div class="route-search">
                                            <div>尚未预订船票</div>
                                            <router-link :to="`/Rccl.Cruise/CruiseSearch/Search?offset=0&destinationCodes=${cityPartRecordViewModel.code}`"  class="external">查找该目的地航线</router-link>
                                        </div>
                                        <div class="route-booking">
                                            <div>已经预订船票</div>
                                            <a href="/Rccl.Booking/Booking/BookingSearch" class="external">预约岸上观光产品</a>
                                        </div>
                                        <div style="font-size: 12px; color: #8a8a8a;">
                                            <p style="text-align:left;">
                                                注：上述岸上观光信息仅供参考<br>
                                                1) 请以关联船票后选择的行程及其价格为准。<br/>
                                                2) 目的地的产品及行程仅供参考，实际行程以具体航次和地接社安排为准。<br/>
                                                3) 目的地产品及行程可能因相关政府政策及/或保护公共健康安全之相关要求而取消、变更或调整。<br/>
                                                4) 本站以外预订，请以相关渠道信息为准。
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div v-else>
                                    <div class="route-destination">
                                        <p style="font-size:13px;font-weight:600;text-align:left;margin-left:8px;">温馨提示：该目的地岸上观光产品即将上线，敬请期待！</p>
                                    </div>
                                </div>

                                <div class="tourMode-content cityIntroduction">
                                    <div class="city-intro-title">城市介绍</div>
                                    <div class="city-desc-content">
                                        <div class="city-intro-desc">{{cityPartRecordViewModel.descrption}}</div>
                                        <div class="city-intro-img"><img :src="cityPartRecordViewModel.mobileCityBannerUrl"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 爆款推荐 -->
                <div class="shipDetail-hotCruise scroll-container" id="hotCruise">
                    <PromoCruise></PromoCruise>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
    import api from '@/api'
    import PromoCruise from '@/components/Cruise/PromoCruise'
    import DestinationOption from '@/components/CustomPage/DestinationOption'
    export default {
        name: 'ShorexIntroList',
        components: {
            PromoCruise,
            DestinationOption
        },
        data () {
            return {
                userToken: '',
                shorexIntroList: {},
                cityPartRecordViewModel: {},
                cityPartRecordViewModels: [],
                countryPartRecordViewModels: [],
                shorexIntroPartRecordViewModels: [],
                isShow: false,
                cityId: '',
                cityModel: {},
                countryModel: {},
                continentOptions: []
            }
        },
        beforeMount () {
            this.$store.commit('SET_PAGE_TITLE', '岸上观光')
            this.showPage()
        },
        methods: {
            async showPage () {
                this.$loading.show()
                await this.initPage()
                this.$loading.hide()
            },
            async initPage () {
                this.userToken = this.$store.state.user.userToken
                const cityName = this.$route.query.cityName

                const data = await this.getCityDetail(cityName)
                this.cityPartRecordViewModel = data.cityPartRecordViewModel
                this.cityPartRecordViewModels = data.cityPartRecordViewModels
                this.countryPartRecordViewModels = data.countryPartRecordViewModels
                this.shorexIntroPartRecordViewModels = data.shorexIntroPartRecordViewModels

                this.cityId = this.cityPartRecordViewModel.id
                this.cityModel = this.cityPartRecordViewModels.find(item => item.id === this.cityId)
                this.countryPartRecordViewModels.map((item) => {
                    console.log(item.countryCNName + '--城市列表：', item.cityPartRecords);
                    if (item.cityPartRecords) {
                        const city = item.cityPartRecords.find(item2 => item2.id === this.cityId)
                        if (city) this.countryModel = item
                    }
                })

                // 初始化
                this.continentOptions = this.getOptionsList(this.countryPartRecordViewModels)
                console.log(this.continentOptions)

            },
            async getCityDetail (cityName) {
                const {success, data, errMsg} = await api.page.getCityDetail(cityName)
                if (!success) {
                    console.log(errMsg)
                    return null
                } else {
                    return data
                }
            },
            getCruiseTitle(cruises) {
                let cruiseArray = []
                cruises.forEach((cruise)=> {
                    cruiseArray.push(cruise.shipName+cruise.sailDate)
                })
                return cruiseArray.join(' / ')
            },
            showDestinationOption () {
                this.isShow = true
            },
            closeOption () {
                this.isShow = false
            },
            getOptionsList (data) {
                let result = [];
                for (const item of data) {
                    let target = {
                        continent: item.continent,
                        list: []
                    }
                    for (const item2 of data) {
                        if (item2.continent === target.continent) {
                            target.list.push(item2)
                        }
                    }
                    if (!result.find(item3 => item3.continent === target.continent)) result.push(target)
                }
                return result
            }
        }
    }
</script>

<style scoped lang="less">
    .pages{
        height: calc( 100vh - 50px );
    }
    .page {
        display: block;
        height: 100%;
        background: #F6F7F8 !important;
        overflow: hidden;
    }
    .page-content{
        width: 100%;
        padding-top: 40px;
        overflow-x: hidden;
    }
    .shorexIntroduction-content{
        overflow: auto;
    }

    /*岸上观光*/
    .shore-sightseeing-content .shore-sightseeing-bg{
        position:fixed;
        width:100%;
        height:100%;
        top:0;
        background:#000;
        opacity:.8;
    }
    .banner-titleImg {
        width:100%;
    }
    .banner-titleImg img{
        width:100%;
    }
    .banner-title {
        background: #fff;
        padding: 10px 15px;
        font-size: 12px;
        font-weight: 600;
        color: #f5be35;
        position: absolute;
        width: 100%;
        z-index: 10;
    }
    .banner-title .title-isletCountryCity span{
        color:#000;
    }
    .banner-desinaRoute{
        background:#fff;
        padding-top:10px;
    }
    .banner-desinaRoute .desinationRoute-txt{
        background:#f0af11;
        text-align:center;
        color:#fff;
        font-size:12px;
        width:350px;
        height:40px;
        line-height:40px;
        margin:0 auto;
    }
    .banner-desinaRoute .desinationRoute-txt a{
        display:inline-block;
        width:100%;
        color:#fff;
    }
    .swiper-button-prev,
    .swiper-button-next{
        background-size:20px;
    }
    .banner-title .title-isletCountryCity,
    .banner-title .replace-desination{
        display:inline-block;
        vertical-align:top;
    }

    .banner-title .title-isletCountryCity{
        width:80%;
        height:18px;
        overflow:hidden;
    }

    .banner-title .replace-desination{
        width:65px;
        height:20px;
        overflow:hidden;
        border:1px solid #f4c655;
        text-align:center;
        border-radius:3px;
        padding:1px 0;
    }

    .shore-sightseeing-content .shore-sightseeing{}
    .shore-sightseeing .sightseeing-content{
        background:#fff;
        position:relative;
    }

    .sightseeing-content .sightseeing-title{
        color:#061556;
        font-size:12px;
        font-weight:600;
        text-align:center;
        padding:15px 0;
        border-bottom:1px solid #d3d3d3;
        width:353px;
        height:52px;
        overflow:hidden;
    }
    .sightseeing-content .sightseeing-close{
        position:absolute;
        width:25px;
        height:25px;
        overflow:hidden;
        top:5px;
        right:5px;
    }
    .sightseeing-content .sightseeing-close img{
        width:100%;
    }
    .title-reason .safe-service-content{
        display:inline-block;
        width:100px;
        overflow:hidden;
        vertical-align:top;
    }
    .safe-service-content .safe-service-titile{
        text-align:center;
        padding:15px 0;
    }
    .safe-service-content .safe-service-intro{
        text-align:justify;
    }
    .safe-service-titile .service-title-step,
    .safe-service-titile .service-title-txt{
        display:inline-block;
        vertical-align:middle;
    }
    .safe-service-titile .service-title-step {
        color: #1c75bc;
        font-size: 22px;
        font-weight: 600;
        width: 25px;
        height: 33px;
        overflow: hidden;
    }
    .safe-service-titile .service-title-txt,
    .safe-service-content .safe-service-intro {
        color: #8a8a8a;
        font-size: 12px;
        width: 100px;
    }
    .safe-service-titile .service-title-txt {
        /*width:48px;
        height:36px;*/
        width:30px;
        overflow: hidden;
        color: #1c75bc;
    }
    .shightseeing-reason-content .title-reason{
        background:#fff;
        padding-bottom:20px;
    }
    .title-reason .safe-step1{
        margin-left:12px;
    }
    .title-reason .safe-step2,
    .title-reason .safe-step3{
        margin-left:10px;
    }
    .shore-sightseeing .tourMode-content{
        background:#fff;
        margin-top:10px;
        padding:0 10px;
    }
    .tourMode-content .tourMode-title{
        text-align:center;
        color:#061556;
        font-size:12px;
        font-weight:600;
        padding:10px 0;
        border-bottom:1px solid #d3d3d3;
        width:333px;
        height:42px;
        overflow:hidden;
    }
    .shore-sightseeing-contentBg{
        padding-bottom: 10px;
        background:#e4e4e4;
    }
    .tourMode-content .tourMode-title-img{
        width:327px;
        max-height:187px;
        overflow:hidden;
        margin:10px auto;
    }
    .tourMode-title-img img{
        width:100%;
    }
    .tourMode-imgIntro .imgIntro-title {
        /*color: #061556;
        font-size: 12px;
        font-weight: 600;*/
        font-size: 17px;
        color: #000;
        font-weight: 500;
        width: 313px;
    }
    .tourMode-imgIntro .imgIntro-title-txt{
        color:#696969;
        font-size:12px;
        width:313px;
    }
    .tourMode-imgIntro .imgIntro-content{
        padding:10px;
        border-bottom:1px dotted #c3c3c3;
        padding-top:0;
    }
    .tour-time-price .tour-time,
    .tour-time-price .tour-price{
        display:inline-block;
        vertical-align:top;
        font-size:12px;
        color:#343434;
        font-weight:600;
    }
    .tour-time .tour-tags{
        color:#0073a1;
        border:1px solid #0073a1;
        border-radius:5px;
        padding:0 3px;
        margin-left:10px;
    }
    .tour-describe-content .tour-time-price{
        padding:10px 5px;
    }
    .tour-time-price .tour-time{
        width:200px;
        height:26px;
        line-height:20px;
        overflow:hidden;
    }
    .tour-time-price .tour-time img,
    .tour-time-price .tour-price img{
        width:15px;
        vertical-align:text-bottom;
        margin-right:5px;
    }
    .tour-time-price .tour-time .time_txt,
    .tour-time-price .tour-time .tour-tags{
        display:inline-block;
    }
    .tour-time-price .tour-time .boutique--foodSign {
        text-align: center;
        height: 24px;
        line-height: 24px;
        background-color: #050656;
        display: inline-block;
        padding: 0 6px;
        margin-left: 6px;
        vertical-align: middle;
    }

    .tour-time-price .tour-time .boutique--foodSign span {
        color: #fff;
        font-size: 12px;
        vertical-align: middle;
    }

    .tour-time-price .tour-price{
        width:118px;
        height:20px;
        line-height:20px;
        overflow:hidden;
        text-align:right;
    }
    .tour-time-price .tour-price .price_txt{
        display:inline-block;
    }
    .tour-describe {
        .describe-txt {
            color: #666;
            font-size: 14px;
            /* width: 333px; */
            margin: 0px 8px;
            text-align: left;
        }
        .boutique--tour-recentSail {
            text-align: left;
            margin: 0px 8px;
            img {
                width: 20px;
                vertical-align: bottom;
                margin-right: 4px;
            }
            span {
                font-size: 13px;
                color: #666;
            }
        }
    }
    
    .route-destination .route-search,
    .route-destination .route-booking{
        display:inline-block;
        font-size:14px;
        text-align:center;
        width:160px;

    }



    .route-destination .route-search a,
    .route-destination .route-booking a {
        color: #fff;
        display: block;
        width: 100%;
        background: #f0af11;
        height: 36px;
        line-height: 36px;
        color: #fff;
        border-radius: 3px;
    }
    .route-destination .route-search{
        margin-right:5px;
    }
    .route-destination {
        margin-top: 10px;
        background-color: white;
        padding: 10px 10px;
        text-align: center;
    }
    .tour-describe-content .tour-describe {
        padding-bottom: 10px;
        border-bottom: 1px dotted #c3c3c3;
        text-align: center;
    }
    .tourMode-content .routine-tour-title{
        color:#061556;
        font-size:14px;
        text-align:center;
        border-bottom:1px solid #b7b7b7;
        font-weight:600;
        padding:10px 0;
        width:333px;
        height:42px;
        overflow:hidden;
    }
    .routine-place-desc .place-title-time,
    .routine-place-desc .royal-gift{
        display:inline-block;
        vertical-align:top;
    }
    .place-title-time .place-time{
        color:#000;
        font-size:14px;
        font-weight:600;
        width:250px;
        height:21px;
        overflow:hidden;
    }
    .place-title-time .place-title{
        color:#818181;
        font-size:12px;
        font-weight:600;
        width:250px;
        height:18px;
        overflow:hidden;
    }
    .routine-place-desc .place-title-time{
        width:250px;
        height:39px;
        overflow:hidden;
    }
    .routine-place-desc .royal-gift{
        width:70px;
        height:39px;
        overflow:hidden;
        text-align:right;
        color:#0e77a3;
        font-size:14px;
        font-weight:600;
        line-height:35px;
    }
    .tourMode-content .routine-place-content{
        padding:15px 0;
    }
    .routine-place-content .routine-place-desc{
        margin-bottom:5px;
    }
    .tourMode-content .city-intro-title{
        color:#061556;
        text-align:center;
        font-size:12px;
        font-weight:600;
        padding:10px 0;
        border-bottom:1px solid #acacac;
        height:42px;
        overflow:hidden;
    }
    .tourMode-content .city-intro-desc{
        font-size:14px;
        color:#666;
        padding:10px;
    }
    .tourMode-content .city-intro-img{
        width:335px;
        margin: 5px auto 0;
    }
    .tourMode-content .city-intro-img img{
        width:100%;
    }
    .tourMode-content .city-desc-content{
        padding-bottom:15px;
    }
    .swiper-container {
        width: 100%;
        height: 100%;
        margin-left: auto;
        margin-right: auto;
    }
    .swiper-slide {
        text-align: center;
        font-size: 18px;
        background: #fff;

        /* Center slide text vertically */
        display: -webkit-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        -webkit-justify-content: center;
        justify-content: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -webkit-align-items: center;
        align-items: center;
    }

    /**** 爆款推荐 ****/
    .shipDetail-hotCruise {
        background-color: #fff;
        /* padding-left: 3.2%;
        padding-right: 3.2%; */
        padding-bottom: 50px;
    }
</style>
